import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import store from 'app/store';
import ErrorBoundary from 'components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'assets/styles/global.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: registration => {
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      const event = new CustomEvent('kvo:pwa-update', { detail: { waitingWorker } });
      window.dispatchEvent(event);
    }
  }
});
